import React, { FC } from 'react';
import { Medium } from "@/constants/mediums";
import ReadingsDetailPage from "@/components/readings/ReadingsDetailPage";

const ElectricityReadingsDetailPage: FC = () => {
  return <ReadingsDetailPage medium={Medium.electricity} />;
};

export default ElectricityReadingsDetailPage;
